import * as C from 'actions/constants';

const initialState = {
  list: [],
  loading: false,
  error: false,
  meta: {
    records_count: 0,
  },
};

export default function insights(state = initialState, action) {
  switch (action.type) {
    case C.LOAD_INSIGHTS:
    case C.CREATE_INSIGHT:
    case C.DELETE_INSIGHT:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case C.LOAD_INSIGHTS_SUCCESS:
      return {
        ...state,
        list: action.data.list,
        meta: action.data.meta || { records_count: 0 },
        loading: false,
        error: false,
      };
    case C.CREATE_INSIGHT_SUCCESS:
    case C.DELETE_INSIGHT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case C.LOAD_INSIGHTS_ERROR:
    case C.CREATE_INSIGHT_ERROR:
    case C.DELETE_INSIGHT_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
} 